import React from "react";
import { Outlet } from "react-router-dom";
// import HeaderLanding from "../../pages/landing-react/layout/HeaderLanding";

const PublicLayout = () => {
  return (
    <>
      {/* <HeaderLanding /> */}
      <Outlet />
    </>
  );
};

export default PublicLayout;
